export default __webpack_public_path__ + "static/media/android.0e98c1a9.png";